import { useSelector } from "react-redux";
import { getMenus } from "store/userSlice";
import { Outlet, useLocation, useOutletContext } from "react-router-dom";
import Link from "components/ui/Link";
import { useTranslation } from "translation/useTranslation";

export default function Index() {
  const location = useLocation();

  const { editableTranslate } = useTranslation();

  const { helps } = useOutletContext();

  return (
    <div className="row flex-nowrap">
      <div className="col-lg-auto col-md-3 section-col-left d-flex">
        <div className="bg-white w-100 p-4 content-card">
          <ul className="sidebar-nav nav nav-pills flex-column sticky" data-testid="initial-setup-nav">
            <li className="nav-item">
              <Link to="import-sources" className={`nav-link ${location.pathname.includes('import-sources') ? 'active' : ''}`} data-testid="nav-item-import-sources">
                <i className={`bi bi-server pr-2`}></i> {editableTranslate('initial_setup.import_sources')}
              </Link>
            </li>
            <li className="nav-item">
              <Link to="login-users" className={`nav-link ${location.pathname.includes('login-users') ? 'active' : ''}`} data-testid="nav-item-login-users">
                <i className={`bi bi-people pr-2`}></i> {editableTranslate('initial_setup.login_users', 'Login Benutzende')}
              </Link>
            </li>
            <li className="nav-item">
              <Link to="roles" className={`nav-link ${location.pathname.includes('roles') ? 'active' : ''}`} data-testid="nav-item-roles">
                <i className={`bi bi-shield-lock pr-2`}></i> {editableTranslate('initial_setup.roles', 'Rollen')}
              </Link>
            </li>
            <li className="nav-item">
              <Link to="email" className={`nav-link ${location.pathname.includes('email') ? 'active' : ''}`} data-testid="nav-item-email">
                <i className={`bi bi-envelope pr-2`}></i> {editableTranslate('initial_setup.email', 'E-Mail-Einstellungen')}
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <Outlet context={{ helps }} />
    </div>
  );
}
